
import React, { useState } from 'react';
import './SalseQuotation.css';

const SalesQuotation = () => {
  // Current user (Sales Executive)
  const currentUser = {
    name: 'Karan (Exec)',
    role: 'Sales Executive',
    email: 'karan@excell.com'
  };

  // My submitted quotations (Sales Executive's own quotations) with version history
  const [myQuotations, setMyQuotations] = useState([
    {
      id: 1,
      enquiryNo: 'ENQ-M3N40',
      client: 'Acme Industries',
      quote: '₹2,75,000',
      status: 'Pending Approval',
      submittedDate: '2024-12-10',
      requirements: 'Service contract renewal for existing automation setup',
      timeline: '2 weeks',
      approvalLevel: 'Manager Pending',
      remarks: 'Quote submitted for service contract',
      currentVersion: 1,
      clientIdGenerated: false,
      versions: [
        {
          version: 1,
          quote: '₹2,75,000',
          submittedDate: '2024-12-10',
          status: 'Pending Approval',
          remarks: 'Quote submitted for service contract'
        }
      ]
    },
    {
      id: 2,
      enquiryNo: 'ENQ-X1Y2Z',
      client: 'Tech Solutions',
      quote: '₹9,20,000',
      status: 'Approved',
      submittedDate: '2024-12-05',
      requirements: '500 units of SKU-204, custom branding',
      timeline: '6 weeks',
      approvalLevel: 'Approved by Manager',
      approvedBy: 'Neha (Manager)',
      approvedDate: '2024-12-06',
      remarks: 'Client accepted the quote',
      currentVersion: 1,
      clientIdGenerated: false,
      versions: [
        {
          version: 1,
          quote: '₹9,20,000',
          submittedDate: '2024-12-05',
          status: 'Approved',
          approvedBy: 'Neha (Manager)',
          approvedDate: '2024-12-06',
          remarks: 'Client accepted the quote'
        }
      ]
    },
    {
      id: 3,
      enquiryNo: 'ENQ-P9Q3R',
      client: 'Nimbus Tech',
      quote: '₹16,50,000',
      status: 'Approved',
      submittedDate: '2024-12-08',
      requirements: 'Cloud infrastructure setup and migration services',
      timeline: '8 weeks',
      approvalLevel: 'Approved by Admin',
      approvedBy: 'Aarav (Admin)',
      approvedDate: '2024-12-09',
      remarks: 'Contract signed',
      currentVersion: 2,
      clientIdGenerated: false,
      versions: [
        {
          version: 1,
          quote: '₹15,00,000',
          submittedDate: '2024-12-07',
          status: 'Revised',
          remarks: 'Initial quote too low'
        },
        {
          version: 2,
          quote: '₹16,50,000',
          submittedDate: '2024-12-08',
          status: 'Approved',
          approvedBy: 'Aarav (Admin)',
          approvedDate: '2024-12-09',
          remarks: 'Contract signed'
        }
      ]
    },
    {
      id: 4,
      enquiryNo: 'ENQ-R7S8T',
      client: 'Orbit Logistics',
      quote: '₹13,20,000',
      status: 'Rejected',
      submittedDate: '2024-12-12',
      requirements: 'Fleet management software with real-time tracking',
      timeline: '10 weeks',
      approvalLevel: 'Rejected',
      rejectedBy: 'Neha (Manager)',
      rejectedDate: '2024-12-13',
      rejectionReason: 'Budget too high, need competitive pricing',
      remarks: 'Please revise quote with better pricing',
      currentVersion: 1,
      clientIdGenerated: false,
      versions: [
        {
          version: 1,
          quote: '₹13,20,000',
          submittedDate: '2024-12-12',
          status: 'Rejected',
          rejectedBy: 'Neha (Manager)',
          rejectedDate: '2024-12-13',
          rejectionReason: 'Budget too high, need competitive pricing',
          remarks: 'Please revise quote with better pricing'
        }
      ]
    },
    {
      id: 5,
      enquiryNo: 'ENQ-U5V6W',
      client: 'BluePeak Foods',
      quote: '₹6,00,000',
      status: 'Pending Approval',
      submittedDate: '2024-12-15',
      requirements: 'Cold storage monitoring system',
      timeline: '4 weeks',
      approvalLevel: 'Waiting for Review',
      remarks: 'Urgent requirement, client awaiting response',
      currentVersion: 1,
      clientIdGenerated: false,
      versions: [
        {
          version: 1,
          quote: '₹6,00,000',
          submittedDate: '2024-12-15',
          status: 'Pending Approval',
          remarks: 'Urgent requirement, client awaiting response'
        }
      ]
    }
  ]);

  // State for view details modal
  const [isViewDetailsModalOpen, setIsViewDetailsModalOpen] = useState(false);
  const [isReviseModalOpen, setIsReviseModalOpen] = useState(false);
  const [isVersionHistoryModalOpen, setIsVersionHistoryModalOpen] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [reviseForm, setReviseForm] = useState({
    newQuote: '',
    reason: '',
    notes: ''
  });

  // State for manual edit (approve/reject) modal
  const [isManualEditModalOpen, setIsManualEditModalOpen] = useState(false);
  const [manualEditForm, setManualEditForm] = useState({
    action: '', // 'approve' or 'reject'
    remarks: '',
    quoteAmount: ''
  });

  // State for generate client ID modal
  const [isGenerateClientModalOpen, setIsGenerateClientModalOpen] = useState(false);
  const [generateClientForm, setGenerateClientForm] = useState({
    clientId: '',
    clientName: '',
    email: '',
    phone: '',
    company: '',
    address: '',
    gstNumber: ''
  });
  const [generatedClients, setGeneratedClients] = useState([]);

  // Filter states
  const [statusFilter, setStatusFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  // Get status badge class
  const getStatusClass = (status) => {
    switch(status) {
      case 'Approved': return 'sq-status-approved';
      case 'Rejected': return 'sq-status-rejected';
      case 'Pending Approval': return 'sq-status-pending';
      case 'Revised': return 'sq-status-revised';
      default: return 'sq-status-pending';
    }
  };

  // Get version badge class
  const getVersionBadgeClass = (version, currentVersion) => {
    if (version === currentVersion) return 'sq-current-version';
    return 'sq-old-version';
  };

  // View quotation details
  const handleViewDetails = (quotation) => {
    setSelectedQuotation(quotation);
    setIsViewDetailsModalOpen(true);
  };

  // View version history
  const handleViewVersionHistory = (quotation) => {
    setSelectedQuotation(quotation);
    setIsVersionHistoryModalOpen(true);
  };

  // Open revise modal
  const handleReviseQuote = (quotation) => {
    setSelectedQuotation(quotation);
    setReviseForm({
      newQuote: '',
      reason: '',
      notes: ''
    });
    setIsReviseModalOpen(true);
  };

  // Open manual edit modal (for approve/reject)
  const handleManualEdit = (quotation) => {
    setSelectedQuotation(quotation);
    setManualEditForm({
      action: '',
      remarks: '',
      quoteAmount: quotation.quote
    });
    setIsManualEditModalOpen(true);
  };

  // Open generate client ID modal
  const handleOpenGenerateClientModal = (quotation) => {
    setSelectedQuotation(quotation);
    // Pre-fill form with client data from quotation
    setGenerateClientForm({
      clientId: `CLT-${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
      clientName: quotation.client,
      email: '',
      phone: '',
      company: quotation.client,
      address: '',
      gstNumber: ''
    });
    setIsGenerateClientModalOpen(true);
  };

  // Generate client ID (save to local state)
  const handleGenerateClientId = () => {
    // Validate required fields
    if (!generateClientForm.clientName.trim()) {
      alert('Please enter client name');
      return;
    }
    if (!generateClientForm.email.trim()) {
      alert('Please enter email address');
      return;
    }
    if (!generateClientForm.phone.trim()) {
      alert('Please enter phone number');
      return;
    }

    // Create new client object
    const newClient = {
      id: generateClientForm.clientId,
      name: generateClientForm.clientName,
      email: generateClientForm.email,
      phone: generateClientForm.phone,
      company: generateClientForm.company,
      address: generateClientForm.address,
      gstNumber: generateClientForm.gstNumber,
      generatedDate: new Date().toISOString().split('T')[0],
      generatedBy: currentUser.name,
      enquiryNo: selectedQuotation?.enquiryNo || 'N/A'
    };

    // Save to local state (simulating database)
    setGeneratedClients(prev => [...prev, newClient]);
    
    // Update the quotation's clientIdGenerated flag to true
    const updatedQuotations = myQuotations.map(q => {
      if (q.id === selectedQuotation.id) {
        return {
          ...q,
          clientIdGenerated: true,
          generatedClientId: newClient.id,
          generatedClientData: newClient
        };
      }
      return q;
    });
    setMyQuotations(updatedQuotations);
    
    // Show success message
    alert(`✅ Client ID Generated Successfully!\n\nClient ID: ${newClient.id}\nClient Name: ${newClient.name}\n\nThis client has been saved to the client database.`);
    
    // Close modal and reset form
    setIsGenerateClientModalOpen(false);
    setGenerateClientForm({
      clientId: '',
      clientName: '',
      email: '',
      phone: '',
      company: '',
      address: '',
      gstNumber: ''
    });
  };

  // Submit manual edit (approve/reject)
  const handleSubmitManualEdit = () => {
    if (!manualEditForm.action) {
      alert('Please select either Approve or Reject');
      return;
    }

    const today = new Date().toISOString().split('T')[0];
    const currentVersion = selectedQuotation.currentVersion || 1;
    const currentVersionData = selectedQuotation.versions.find(v => v.version === currentVersion) || selectedQuotation.versions[selectedQuotation.versions.length - 1];

    let updatedVersions = [...selectedQuotation.versions];
    let updatedStatus = '';
    let updatedApprovalLevel = '';
    let updatedRemarks = manualEditForm.remarks || (manualEditForm.action === 'approve' ? 'Manually approved by Sales Executive' : 'Manually rejected by Sales Executive');
    let updatedApprovedBy = null;
    let updatedApprovedDate = null;
    let updatedRejectedBy = null;
    let updatedRejectedDate = null;
    let updatedRejectionReason = null;
    let updatedQuote = manualEditForm.quoteAmount || selectedQuotation.quote;

    if (manualEditForm.action === 'approve') {
      updatedStatus = 'Approved';
      updatedApprovalLevel = `Approved by ${currentUser.role}`;
      updatedApprovedBy = `${currentUser.name}`;
      updatedApprovedDate = today;
      
      // Update the current version in versions array
      updatedVersions = updatedVersions.map(v => {
        if (v.version === currentVersion) {
          return {
            ...v,
            status: 'Approved',
            approvedBy: updatedApprovedBy,
            approvedDate: updatedApprovedDate,
            remarks: updatedRemarks,
            quote: updatedQuote
          };
        }
        return v;
      });
    } else {
      updatedStatus = 'Rejected';
      updatedApprovalLevel = 'Rejected';
      updatedRejectedBy = `${currentUser.name}`;
      updatedRejectedDate = today;
      updatedRejectionReason = manualEditForm.remarks || 'Manually rejected by Sales Executive';
      
      // Update the current version in versions array
      updatedVersions = updatedVersions.map(v => {
        if (v.version === currentVersion) {
          return {
            ...v,
            status: 'Rejected',
            rejectedBy: updatedRejectedBy,
            rejectedDate: updatedRejectedDate,
            rejectionReason: updatedRejectionReason,
            remarks: updatedRemarks,
            quote: updatedQuote
          };
        }
        return v;
      });
    }

    // Update the quotation
    const updatedQuotations = myQuotations.map(q => {
      if (q.id === selectedQuotation.id) {
        return {
          ...q,
          quote: updatedQuote,
          status: updatedStatus,
          approvalLevel: updatedApprovalLevel,
          remarks: updatedRemarks,
          approvedBy: updatedApprovedBy || q.approvedBy,
          approvedDate: updatedApprovedDate || q.approvedDate,
          rejectedBy: updatedRejectedBy || q.rejectedBy,
          rejectedDate: updatedRejectedDate || q.rejectedDate,
          rejectionReason: updatedRejectionReason || q.rejectionReason,
          versions: updatedVersions
        };
      }
      return q;
    });

    setMyQuotations(updatedQuotations);
    alert(`✓ Quotation ${manualEditForm.action === 'approve' ? 'Approved' : 'Rejected'} successfully by ${currentUser.name}`);
    setIsManualEditModalOpen(false);
    setSelectedQuotation(null);
    setManualEditForm({ action: '', remarks: '', quoteAmount: '' });
  };

  // Submit revised quotation (new version)
  const handleSubmitRevision = () => {
    if (!reviseForm.newQuote) {
      alert('Please enter revised quote amount');
      return;
    }

    const nextVersion = (selectedQuotation.versions?.length || 0) + 1;
    const newVersion = {
      version: nextVersion,
      quote: reviseForm.newQuote.startsWith('₹') ? reviseForm.newQuote : `₹${reviseForm.newQuote}`,
      submittedDate: new Date().toISOString().split('T')[0],
      status: 'Pending Approval',
      remarks: reviseForm.notes || reviseForm.reason || 'Revised quote submitted'
    };

    // Update the quotation with new version
    const updatedQuotations = myQuotations.map(q => {
      if (q.id === selectedQuotation.id) {
        return {
          ...q,
          quote: newVersion.quote,
          status: 'Pending Approval',
          submittedDate: newVersion.submittedDate,
          remarks: newVersion.remarks,
          approvalLevel: 'Manager Pending',
          rejectedBy: null,
          rejectedDate: null,
          rejectionReason: null,
          currentVersion: nextVersion,
          versions: [...(q.versions || []), newVersion]
        };
      }
      return q;
    });

    setMyQuotations(updatedQuotations);
    alert(`✓ Version ${nextVersion} submitted with revised quote of ${newVersion.quote}`);
    setIsReviseModalOpen(false);
    setSelectedQuotation(null);
    setReviseForm({ newQuote: '', reason: '', notes: '' });
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  // Filter quotations
  const filteredMyQuotations = myQuotations.filter(q => {
    const matchesStatus = statusFilter === 'All' || q.status === statusFilter;
    const matchesSearch = 
      q.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
      q.enquiryNo.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  // Statistics
  const totalSubmitted = myQuotations.length;
  const approvedCount = myQuotations.filter(q => q.status === 'Approved').length;
  const rejectedCount = myQuotations.filter(q => q.status === 'Rejected').length;
  const pendingCount = myQuotations.filter(q => q.status === 'Pending Approval').length;
  const totalVersions = myQuotations.reduce((sum, q) => sum + (q.versions?.length || 1), 0);

  return (
    <div className="sq-container">
      <div className="sq-wrapper">
      
        {/* Filters */}
        <div className="sq-filters">
          <div className="sq-search-box">
            <input 
              type="text"
              placeholder="🔍 Search by client or enquiry #..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="sq-search-input"
            />
          </div>
          <select className="sq-filter-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="All">All Status</option>
            <option value="Pending Approval">Pending Approval</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
          <button className="sq-clear-filters" onClick={() => {
            setSearchTerm('');
            setStatusFilter('All');
          }}>Clear</button>
        </div>

        {/* My Quotations Table */}
        <div className="sq-section">
          <h2 className="sq-section-title">📋 My Submitted Quotations</h2>
          <div className="sq-table-responsive">
            <table className="sq-table">
              <thead>
                <tr>
                  <th>ENQUIRY #</th>
                  <th>CLIENT</th>
                  <th>QUOTE AMOUNT</th>
                  <th>VERSION</th>
                  <th>SUBMITTED DATE</th>
                  <th>STATUS</th>
                  <th>APPROVAL LEVEL</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredMyQuotations.map((item) => (
                  <tr key={item.id}>
                    <td className="sq-cell-enquiry">{item.enquiryNo}</td>
                    <td>{item.client}</td>
                    <td className="sq-cell-quote">{item.quote}</td>
                    <td>
                      <button 
                        className="sq-version-btn"
                        onClick={() => handleViewVersionHistory(item)}
                        title="View Version History"
                      >
                        v{item.currentVersion || 1}
                      </button>
                    </td>
                    <td>{formatDate(item.submittedDate)}</td>
                    <td>
                      <span className={`sq-status-badge ${getStatusClass(item.status)}`}>
                        {item.status}
                      </span>
                    </td>
                    <td>
                      {item.approvalLevel && (
                        <span className="sq-approval-level">{item.approvalLevel}</span>
                      )}
                    </td>
                    <td className="sq-action-cell">
                      <div className="sq-action-buttons">
                        <button 
                          className="sq-view-btn" 
                          onClick={() => handleViewDetails(item)}
                        >
                          View 
                        </button>
                        {item.status === 'Rejected' && (
                          <button 
                            className="sq-revise-btn" 
                            onClick={() => handleReviseQuote(item)}
                          >
                            Revise 
                          </button>
                        )}
                        {/* Manual Edit button */}
                        <button 
                          className="sq-manual-edit-btn" 
                          onClick={() => handleManualEdit(item)}
                          title="Manually Approve/Reject (Sales Executive Authority)"
                        >
                          ✏️Edit
                        </button>
                        {/* Generate Client ID button with tick mark after generation */}
                        <button 
                          className={`sq-generate-client-btn ${item.clientIdGenerated ? 'sq-generated' : ''}`} 
                          onClick={() => !item.clientIdGenerated && handleOpenGenerateClientModal(item)}
                          title={item.clientIdGenerated ? `Client ID Generated: ${item.generatedClientId}` : "Generate Client ID"}
                          disabled={item.clientIdGenerated}
                        >
                          {item.clientIdGenerated ? (
                            <>
                              ✅ {item.generatedClientId}
                            </>
                          ) : (
                            '🆔 Gen ID'
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {filteredMyQuotations.length === 0 && (
                  <tr>
                    <td colSpan="8" className="sq-empty-row">No quotations found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Quick Stats Card */}
        <div className="sq-quick-info">
          <div className="sq-info-card">
            <div className="sq-info-icon">💡</div>
            <div className="sq-info-content">
              <h4>Quick Tips</h4>
              <ul>
                <li>• Click on version number to see complete version history</li>
                <li>• Rejected quotations can be revised as new version</li>
                <li>• Each revision creates a new version for tracking</li>
                <li>• Approved quotations are final and cannot be modified</li>
                <li>• Contact your manager for urgent approvals</li>
                <li>• <strong>✏️ Edit:</strong> Sales Executives can directly Approve/Reject any quotation</li>
                <li>• <strong>🆔 Gen ID:</strong> Generate a unique Client ID and save client details (turns into ✅ with ID after generation)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Display generated clients list (optional - for debugging/verification) */}
        {/* {generatedClients.length > 0 && (
          <div className="sq-section sq-generated-clients-section">
            <h3 className="sq-section-title">🏢 Recently Generated Clients</h3>
            <div className="sq-table-responsive">
              <table className="sq-table sq-clients-table">
                <thead>
                  <tr>
                    <th>Client ID</th>
                    <th>Client Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Generated By</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {generatedClients.slice(-5).reverse().map((client, idx) => (
                    <tr key={idx}>
                      <td className="sq-client-id-cell">{client.id}</td>
                      <td>{client.name}</td>
                      <td>{client.email}</td>
                      <td>{client.phone}</td>
                      <td>{client.generatedBy}</td>
                      <td>{formatDate(client.generatedDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )} */}
      </div>

      {/* View Details Modal */}
      {isViewDetailsModalOpen && selectedQuotation && (
        <div className="sq-modal-overlay" onClick={() => setIsViewDetailsModalOpen(false)}>
          <div className="sq-modal sq-details-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sq-modal-header">
              <h3>Quotation Details - {selectedQuotation.enquiryNo}</h3>
              <button className="sq-modal-close" onClick={() => setIsViewDetailsModalOpen(false)}>×</button>
            </div>
            <div className="sq-modal-body">
              <div className="sq-details-grid">
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Enquiry #:</span>
                  <span className="sq-detail-value">{selectedQuotation.enquiryNo}</span>
                </div>
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Client:</span>
                  <span className="sq-detail-value">{selectedQuotation.client}</span>
                </div>
                {selectedQuotation.generatedClientId && (
                  <div className="sq-detail-row">
                    <span className="sq-detail-label">Generated Client ID:</span>
                    <span className="sq-detail-value sq-client-id-highlight">✅ {selectedQuotation.generatedClientId}</span>
                  </div>
                )}
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Current Version:</span>
                  <span className="sq-detail-value sq-version-highlight">v{selectedQuotation.currentVersion || 1}</span>
                </div>
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Quote Amount:</span>
                  <span className="sq-detail-value sq-highlight">{selectedQuotation.quote}</span>
                </div>
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Requirements:</span>
                  <span className="sq-detail-value">{selectedQuotation.requirements}</span>
                </div>
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Timeline:</span>
                  <span className="sq-detail-value">{selectedQuotation.timeline}</span>
                </div>
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Submitted Date:</span>
                  <span className="sq-detail-value">{formatDate(selectedQuotation.submittedDate)}</span>
                </div>
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Status:</span>
                  <span className={`sq-status-badge ${getStatusClass(selectedQuotation.status)}`}>
                    {selectedQuotation.status}
                  </span>
                </div>
                
                {selectedQuotation.approvedBy && (
                  <>
                    <div className="sq-detail-row">
                      <span className="sq-detail-label">Approved By:</span>
                      <span className="sq-detail-value">{selectedQuotation.approvedBy}</span>
                    </div>
                    <div className="sq-detail-row">
                      <span className="sq-detail-label">Approved Date:</span>
                      <span className="sq-detail-value">{formatDate(selectedQuotation.approvedDate)}</span>
                    </div>
                  </>
                )}
                
                {selectedQuotation.rejectedBy && (
                  <>
                    <div className="sq-detail-row">
                      <span className="sq-detail-label">Rejected By:</span>
                      <span className="sq-detail-value">{selectedQuotation.rejectedBy}</span>
                    </div>
                    <div className="sq-detail-row">
                      <span className="sq-detail-label">Rejection Date:</span>
                      <span className="sq-detail-value">{formatDate(selectedQuotation.rejectedDate)}</span>
                    </div>
                    <div className="sq-detail-row">
                      <span className="sq-detail-label">Rejection Reason:</span>
                      <span className="sq-detail-value sq-rejection-reason">{selectedQuotation.rejectionReason}</span>
                    </div>
                  </>
                )}
                
                <div className="sq-detail-row">
                  <span className="sq-detail-label">Remarks:</span>
                  <span className="sq-detail-value">{selectedQuotation.remarks || 'No remarks'}</span>
                </div>
              </div>
            </div>
            <div className="sq-modal-footer">
              <button 
                className="sq-version-history-btn"
                onClick={() => {
                  setIsViewDetailsModalOpen(false);
                  handleViewVersionHistory(selectedQuotation);
                }}
              >
                📜 View Version History
              </button>
              {selectedQuotation.status === 'Rejected' && (
                <button className="sq-revise-modal-btn" onClick={() => {
                  setIsViewDetailsModalOpen(false);
                  handleReviseQuote(selectedQuotation);
                }}>
                  🔄 Revise 
                </button>
              )}
              <button className="sq-manual-edit-modal-btn" onClick={() => {
                setIsViewDetailsModalOpen(false);
                handleManualEdit(selectedQuotation);
              }}>
                ✏️ Edit
              </button>
              {!selectedQuotation.clientIdGenerated && (
                <button className="sq-generate-client-modal-btn" onClick={() => {
                  setIsViewDetailsModalOpen(false);
                  handleOpenGenerateClientModal(selectedQuotation);
                }}>
                  🆔 Gen Client ID
                </button>
              )}
              <button className="sq-close-button" onClick={() => setIsViewDetailsModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Version History Modal */}
      {isVersionHistoryModalOpen && selectedQuotation && (
        <div className="sq-modal-overlay" onClick={() => setIsVersionHistoryModalOpen(false)}>
          <div className="sq-modal sq-version-history-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sq-modal-header">
              <h3>Version History - {selectedQuotation.enquiryNo}</h3>
              <button className="sq-modal-close" onClick={() => setIsVersionHistoryModalOpen(false)}>×</button>
            </div>
            <div className="sq-modal-body">
              <div className="sq-client-info">
                <p><strong>Client:</strong> {selectedQuotation.client}</p>
                {selectedQuotation.generatedClientId && (
                  <p><strong>Generated Client ID:</strong> ✅ {selectedQuotation.generatedClientId}</p>
                )}
                <p><strong>Requirements:</strong> {selectedQuotation.requirements}</p>
              </div>
              
              <div className="sq-versions-timeline">
                {selectedQuotation.versions && [...selectedQuotation.versions].reverse().map((ver, index) => (
                  <div 
                    key={ver.version} 
                    className={`sq-version-card ${getVersionBadgeClass(ver.version, selectedQuotation.currentVersion)}`}
                  >
                    <div className="sq-version-header">
                      <span className="sq-version-number">Version {ver.version}</span>
                      {ver.version === selectedQuotation.currentVersion && (
                        <span className="sq-current-badge">Current</span>
                      )}
                      <span className={`sq-version-status ${getStatusClass(ver.status)}`}>
                        {ver.status}
                      </span>
                    </div>
                    
                    <div className="sq-version-details">
                      <div className="sq-version-row">
                        <span className="sq-version-label">Quote:</span>
                        <span className="sq-version-value sq-quote-amount">{ver.quote}</span>
                      </div>
                      <div className="sq-version-row">
                        <span className="sq-version-label">Submitted:</span>
                        <span className="sq-version-value">{formatDate(ver.submittedDate)}</span>
                      </div>
                      
                      {ver.approvedBy && (
                        <div className="sq-version-row">
                          <span className="sq-version-label">Approved By:</span>
                          <span className="sq-version-value sq-approved-text">✓ {ver.approvedBy} on {formatDate(ver.approvedDate)}</span>
                        </div>
                      )}
                      
                      {ver.rejectedBy && (
                        <div className="sq-version-row">
                          <span className="sq-version-label">Rejected By:</span>
                          <span className="sq-version-value sq-rejected-text">✗ {ver.rejectedBy} on {formatDate(ver.rejectedDate)}</span>
                        </div>
                      )}
                      
                      {ver.rejectionReason && (
                        <div className="sq-version-row">
                          <span className="sq-version-label">Rejection Reason:</span>
                          <span className="sq-version-value sq-rejection-text">{ver.rejectionReason}</span>
                        </div>
                      )}
                      
                      <div className="sq-version-row">
                        <span className="sq-version-label">Remarks:</span>
                        <span className="sq-version-value">{ver.remarks || 'No remarks'}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="sq-modal-footer">
              {selectedQuotation.status === 'Rejected' && (
                <button className="sq-revise-modal-btn" onClick={() => {
                  setIsVersionHistoryModalOpen(false);
                  handleReviseQuote(selectedQuotation);
                }}>
                  🔄 Create New Version
                </button>
              )}
              <button className="sq-manual-edit-modal-btn" onClick={() => {
                setIsVersionHistoryModalOpen(false);
                handleManualEdit(selectedQuotation);
              }}>
                ✏️ Edit
              </button>
              {!selectedQuotation.clientIdGenerated && (
                <button className="sq-generate-client-modal-btn" onClick={() => {
                  setIsVersionHistoryModalOpen(false);
                  handleOpenGenerateClientModal(selectedQuotation);
                }}>
                  🆔 Gen Client ID
                </button>
              )}
              <button className="sq-close-button" onClick={() => setIsVersionHistoryModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Revise Modal */}
      {isReviseModalOpen && selectedQuotation && (
        <div className="sq-modal-overlay" onClick={() => setIsReviseModalOpen(false)}>
          <div className="sq-modal sq-revise-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sq-modal-header">
              <h3>Create New Version - {selectedQuotation.enquiryNo}</h3>
              <button className="sq-modal-close" onClick={() => setIsReviseModalOpen(false)}>×</button>
            </div>
            <div className="sq-modal-body">
              <div className="sq-info-box">
                <p><strong>Current Version:</strong> v{selectedQuotation.currentVersion || 1}</p>
                <p><strong>Current Quote:</strong> {selectedQuotation.quote}</p>
                <p><strong>Next Version:</strong> v{(selectedQuotation.versions?.length || 0) + 1}</p>
                {selectedQuotation.rejectionReason && (
                  <p><strong>Rejection Reason:</strong> {selectedQuotation.rejectionReason}</p>
                )}
              </div>

              <div className="sq-form-group">
                <label>Revised Quote Amount <span className="sq-required">*</span></label>
                <input 
                  type="text" 
                  placeholder="e.g., ₹11,50,000" 
                  value={reviseForm.newQuote}
                  onChange={(e) => setReviseForm({...reviseForm, newQuote: e.target.value})}
                />
              </div>

              <div className="sq-form-group">
                <label>Reason for Revision</label>
                <textarea 
                  rows="2"
                  placeholder="Explain why the quote is being revised..."
                  value={reviseForm.reason}
                  onChange={(e) => setReviseForm({...reviseForm, reason: e.target.value})}
                />
              </div>

              <div className="sq-form-group">
                <label>Additional Notes</label>
                <textarea 
                  rows="3"
                  placeholder="Any additional information for the approver..."
                  value={reviseForm.notes}
                  onChange={(e) => setReviseForm({...reviseForm, notes: e.target.value})}
                />
              </div>
            </div>
            <div className="sq-modal-footer">
              <button className="sq-cancel-button" onClick={() => setIsReviseModalOpen(false)}>Cancel</button>
              <button className="sq-submit-button" onClick={handleSubmitRevision}>Submit New Version</button>
            </div>
          </div>
        </div>
      )}

      {/* Manual Edit Modal (Approve/Reject) */}
      {isManualEditModalOpen && selectedQuotation && (
        <div className="sq-modal-overlay" onClick={() => setIsManualEditModalOpen(false)}>
          <div className="sq-modal sq-manual-edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sq-modal-header">
              <h3>✏️ Edit - {selectedQuotation.enquiryNo}</h3>
              <button className="sq-modal-close" onClick={() => setIsManualEditModalOpen(false)}>×</button>
            </div>
            <div className="sq-modal-body">
              <div className="sq-info-box sq-manual-edit-info">
                <p><strong>Client:</strong> {selectedQuotation.client}</p>
                <p><strong>Current Status:</strong> <span className={`sq-status-badge ${getStatusClass(selectedQuotation.status)}`}>{selectedQuotation.status}</span></p>
                <p><strong>Current Quote:</strong> {selectedQuotation.quote}</p>
                <p><strong>Submitted Date:</strong> {formatDate(selectedQuotation.submittedDate)}</p>
                {selectedQuotation.approvalLevel && <p><strong>Approval Level:</strong> {selectedQuotation.approvalLevel}</p>}
              </div>

              <div className="sq-form-group">
                <label>Quote Amount <span className="sq-required">*</span></label>
                <input 
                  type="text" 
                  placeholder="e.g., ₹15,00,000" 
                  value={manualEditForm.quoteAmount}
                  onChange={(e) => setManualEditForm({...manualEditForm, quoteAmount: e.target.value})}
                />
                <small>You can modify the quote amount if needed</small>
              </div>

              <div className="sq-form-group">
                <label>Action <span className="sq-required">*</span></label>
                <div className="sq-radio-group">
                  <label className="sq-radio-label">
                    <input 
                      type="radio" 
                      value="approve" 
                      checked={manualEditForm.action === 'approve'}
                      onChange={() => setManualEditForm({...manualEditForm, action: 'approve'})}
                    />
                    <span className="sq-approve-radio">✅ Approve</span>
                  </label>
                  <label className="sq-radio-label">
                    <input 
                      type="radio" 
                      value="reject" 
                      checked={manualEditForm.action === 'reject'}
                      onChange={() => setManualEditForm({...manualEditForm, action: 'reject'})}
                    />
                    <span className="sq-reject-radio">❌ Reject</span>
                  </label>
                </div>
              </div>

              <div className="sq-form-group">
                <label>Remarks / Reason <span className="sq-required">*</span></label>
                <textarea 
                  rows="3"
                  placeholder={manualEditForm.action === 'approve' ? 'Add approval remarks...' : 'Provide rejection reason...'}
                  value={manualEditForm.remarks}
                  onChange={(e) => setManualEditForm({...manualEditForm, remarks: e.target.value})}
                />
              </div>

              <div className="sq-manual-edit-warning">
                <p>⚠️ <strong>Note:</strong> This action will be recorded with your name ({currentUser.name}) as the authorizer. The version history will be updated accordingly.</p>
              </div>
            </div>
            <div className="sq-modal-footer">
              <button className="sq-cancel-button" onClick={() => setIsManualEditModalOpen(false)}>Cancel</button>
              <button 
                className={`sq-submit-button ${manualEditForm.action === 'approve' ? 'sq-approve-btn' : 'sq-reject-btn'}`} 
                onClick={handleSubmitManualEdit}
              >
                {manualEditForm.action === 'approve' ? '✅ Confirm Approval' : manualEditForm.action === 'reject' ? '❌ Confirm Rejection' : 'Submit'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Generate Client ID Modal */}
      {isGenerateClientModalOpen && selectedQuotation && (
        <div className="sq-modal-overlay" onClick={() => setIsGenerateClientModalOpen(false)}>
          <div className="sq-modal sq-generate-client-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sq-modal-header">
              <h3>🆔 Generate Client ID</h3>
              <button className="sq-modal-close" onClick={() => setIsGenerateClientModalOpen(false)}>×</button>
            </div>
            <div className="sq-modal-body">
              <div className="sq-info-box sq-client-preview">
                <p><strong>Enquiry No:</strong> {selectedQuotation.enquiryNo}</p>
                <p><strong>Quote For:</strong> {selectedQuotation.client}</p>
                <p><strong>Quote Amount:</strong> {selectedQuotation.quote}</p>
              </div>

              <div className="sq-form-group">
                <label>Client ID <span className="sq-required">*</span></label>
                <input 
                  type="text" 
                  value={generateClientForm.clientId}
                  readOnly
                  className="sq-readonly-field"
                />
                <small>Auto-generated unique Client ID</small>
              </div>

              <div className="sq-form-group">
                <label>Client Name <span className="sq-required">*</span></label>
                <input 
                  type="text" 
                  placeholder="Enter client name" 
                  value={generateClientForm.clientName}
                  onChange={(e) => setGenerateClientForm({...generateClientForm, clientName: e.target.value})}
                />
              </div>

              <div className="sq-form-row">
                <div className="sq-form-group sq-half">
                  <label>Email Address <span className="sq-required">*</span></label>
                  <input 
                    type="email" 
                    placeholder="client@example.com" 
                    value={generateClientForm.email}
                    onChange={(e) => setGenerateClientForm({...generateClientForm, email: e.target.value})}
                  />
                </div>
                <div className="sq-form-group sq-half">
                  <label>Phone Number <span className="sq-required">*</span></label>
                  <input 
                    type="tel" 
                    placeholder="+91 XXXXX XXXXX" 
                    value={generateClientForm.phone}
                    onChange={(e) => setGenerateClientForm({...generateClientForm, phone: e.target.value})}
                  />
                </div>
              </div>

              <div className="sq-form-group">
                <label>Company Name</label>
                <input 
                  type="text" 
                  placeholder="Company name" 
                  value={generateClientForm.company}
                  onChange={(e) => setGenerateClientForm({...generateClientForm, company: e.target.value})}
                />
              </div>

              <div className="sq-form-group">
                <label>Address</label>
                <textarea 
                  rows="2"
                  placeholder="Full address of client" 
                  value={generateClientForm.address}
                  onChange={(e) => setGenerateClientForm({...generateClientForm, address: e.target.value})}
                />
              </div>

              <div className="sq-form-group">
                <label>GST Number</label>
                <input 
                  type="text" 
                  placeholder="GSTIN (if applicable)" 
                  value={generateClientForm.gstNumber}
                  onChange={(e) => setGenerateClientForm({...generateClientForm, gstNumber: e.target.value})}
                />
              </div>

              <div className="sq-manual-edit-warning sq-generate-warning">
                <p>📌 <strong>Note:</strong> This will create a permanent client record in the database with a unique Client ID. The client will be associated with this quotation ({selectedQuotation.enquiryNo}).</p>
              </div>
            </div>
            <div className="sq-modal-footer">
              <button className="sq-cancel-button" onClick={() => setIsGenerateClientModalOpen(false)}>Cancel</button>
              <button className="sq-generate-submit-btn" onClick={handleGenerateClientId}>
                💾 Generate & Save Client
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalesQuotation;